import React, { Fragment } from 'react';
import {toast} from 'react-toastify';
import './style.scss';
import Table from '../../../components/table';
import Button from '../../../components/button';
import { connect } from 'react-redux';
import {
    ACTIONS, convertAdminListUsers, getGroupsOfCompany,
    addCompanyGroups, editCompanyGroups, searchGroups, removeGroup,
    convertUsersGroupTable, searchUsers, getUsersInGroupsForDelete,
    getUsersOfGroups, removeUserGroup, addUsersGroups, editUserGroups, updateUserOfGroupCompany
} from '../../../actions/admin-list-users';
import Loading from '../../../components/loading';

class AdminUserList extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isShowDropdown: false,
            isShowTable: true,
            showLoading: false,
            listGroups: [],
            name: '',
            nameEdit: '',
            idUserGroup: '',
            showModalAddGroup: false,
            showModalEditGroup: false,
            message: '',
            idUser: '',
            listUsersInGroup: [],
            showModalRemove: false,
            showModalRemoveUsers: false,
            showModalSettingUser: false,
            isGroupSearch: false,
            showModalAddUser: false,
            listIdGroup: [],
            nameAddUser: '',
            remarkAddUser: '',
            idUserEdit: 0,
            emailUser: '',
            pageCurent: 1,
            pageUserCurrent: 1,
            listUsersRemove: [],
            meta: null,
            showAddUserGroup: false,
            showPopup: false,
            listGroupOfUser: [],
            listUsersRemoveFake: [],
            idGroup: '',
            nameGroupToDelete: '',
            // nameCompany: '',
            name_company: '',
            groupClient: '',
            isReciveProps: false,

            emailAddUser: '',
            password: '',
            formErrors: { emailAddUser: '', password: '' },
            emailValid: false,
            passwordValid: false,
            formValid: false,
        }
    };

    componentWillMount = () => {
        let id = this.props.match.params.id;
        this.props.getGroupsOfCompany(id);
    }


    validateField(fieldName, value) {
        let fieldValidationErrors = this.state.formErrors;
        let passwordValid = this.state.passwordValid;
        let emailValid = this.state.emailValid;
        let isEmpty;
        switch (fieldName) {
            case 'emailAddUser':
                emailValid = value.match(/^([a-zA-Z_0-9]|[ｧ-ﾝﾞﾟ]|[0-9\@\.\_\-])*$/i);
                fieldValidationErrors.emailAddUser = emailValid ? '' : 'is invalid';
                break;
            case 'password':
                isEmpty = this.state.showModalAddUser ? !value ? false : true : true;
                passwordValid = value.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!%*?&]{8,}$/i) && isEmpty;
                fieldValidationErrors.password = passwordValid ? '' : 'is invalid';
                break;
            default:
                break;
        }
        this.setState({
            formErrors: fieldValidationErrors,
            passwordValid: passwordValid,
            emailValid: emailValid
        }, this.validateForm);
    }

    validateForm() {
        this.setState({
            formValid: this.state.showModalAddUser ? this.state.emailValid && this.state.passwordValid : this.state.passwordValid
        });
    }

    UNSAFE_componentWillReceiveProps = (nextProps) => {
        if (nextProps) {
            if (nextProps.status === ACTIONS.GET_GROUPS_SUCCESS) {

                this.setState({
                    showLoading: false,
                    meta: nextProps.meta,
                    listGroups: convertAdminListUsers(nextProps.response),
                });
            }
            if (nextProps.status === ACTIONS.GET_USERS_LIST_DELETE_SUCCESS) {
                this.setState({
                    showLoading: false,
                    listUsersRemove: nextProps.listRemove,
                    listUsersRemoveFake: nextProps.listRemove
                });
            }
            if (nextProps.status === ACTIONS.GET_USERS_LIST_GROUPS_SUCCESS) {
                // console.log(nextProps.response);
                this.setState({
                    showLoading: false,
                    meta: nextProps.meta,
                    listUsersInGroup: convertUsersGroupTable(nextProps.response)
                });
            }
            if (nextProps.status === ACTIONS.ADD_GROUPS_SUCCESS) {
                if (!nextProps.message) {
                    this.setState({
                        showLoading: false,
                        showModalAddGroup: false,
                        showPopup: true,
                        isReciveProps: true
                    }, () => {
                        this.props.getGroupsOfCompany(this.state.idGroup, this.state.pageCurent);
                    });
                    toast.success('グループを追加しました');
                } else {
                    this.setState({
                        showLoading: false,
                        showModalAddGroup: false,
                        message: nextProps.message,
                        isReciveProps: true
                    }, () => {
                        this.props.getGroupsOfCompany(this.state.idGroup, this.state.pageCurent);
                    });
                    toast.success('グループを追加しました');
                }
            }
            if(nextProps.status === ACTIONS.ADD_GROUPS_ERROR) {
                toast.error(nextProps.message);
                this.setState({
                    showLoading: false,
                });
            }
            if (nextProps.status === ACTIONS.ADD_USERS_GROUPS_SUCCESS) {

                if (!nextProps.message) {
                    this.setState({
                        showLoading: false,
                        showModalAddUser: false,
                        showPopup: true,
                        isReciveProps: true,
                        showModalSettingUser: false
                    }, () => {
                        this.props.getUsersOfGroups(this.state.idGroup, this.state.pageUserCurrent);
                    });
                    toast.success('利用者を追加しました');
                } else {
                    this.setState({
                        showLoading: false,
                        showModalSettingUser: false,
                        showModalAddUser: false,
                        message: nextProps.message,
                    }, () => {
                        this.props.getUsersOfGroups(this.state.idGroup, this.state.pageUserCurrent);
                    });
                    toast.success('利用者を追加しました');
                }
            }
            if(nextProps.status === ACTIONS.ADD_USERS_GROUPS_ERROR) {
                this.setState({
                    showLoading: false,
                });
                toast.error(nextProps.message);
            }
            if (nextProps.status === ACTIONS.UPDATE_GROUPS_SUCCESS) {
                if (!nextProps.message) {
                    this.setState({
                        showLoading: false,
                        showModalEditGroup: false
                    }, () => {
                        this.props.getGroupsOfCompany(this.state.idGroup, this.state.pageCurent);
                    });
                    toast.success('グループ名を変更しました');
                } else {
                    this.setState({
                        showLoading: false,
                        showModalEditGroup: false,
                        message: nextProps.message,
                    }, () => {
                        this.props.getGroupsOfCompany(this.state.idGroup, this.state.pageCurent);
                    });
                    toast.success('グループ名を変更しました');
                }
            }
            if (nextProps.status === ACTIONS.UPDATE_USERS_GROUPS_SUCCESS) {
                if (!nextProps.message) {
                    this.setState({
                        showLoading: false,
                        showModalSettingUser: false
                    }, () => {
                        this.props.getUsersOfGroups(this.state.idGroup, this.state.pageUserCurrent);
                    });
                    toast.success('グループに所属する利用者を編集しました');
                } else {
                    this.setState({
                        showLoading: false,
                        showModalSettingUser: false,
                        message: nextProps.message,
                    }, () => {
                        this.props.getUsersOfGroups(this.state.idGroup, this.state.pageUserCurrent);
                    });
                    toast.success('グループに所属する利用者を編集しました');
                }
            }
            if (nextProps.status === ACTIONS.UPDATE_USERS_GROUPS_ERROR) {
                this.setState({
                    showLoading: false,
                });
                toast.error(nextProps.message);
            }
            if (nextProps.status === ACTIONS.REMOVE_GROUP_COMPANY_SUCCESS) {
                if (!nextProps.message) {
                    this.setState({
                        showLoading: false,
                        showModalRemove: false
                    }, () => {
                        this.props.getGroupsOfCompany(this.state.idGroup, this.state.pageCurent);
                    });
                    toast.success('グループを削除しました');
                } else {
                    this.setState({
                        showLoading: false,
                        showModalRemove: false,
                        message: nextProps.message,
                    }, () => {
                        this.props.getGroupsOfCompany(this.state.idGroup, this.state.pageCurent);
                    });
                    toast.success('グループを削除しました');
                }
            }
            if (nextProps.status === ACTIONS.REMOVE_USERS_GROUP_SUCCESS) {
                if (!nextProps.message) {
                    this.setState({
                        showLoading: false,
                        showModalRemoveUsers: false
                    }, () => {
                        this.props.getGroupsOfCompany(this.state.idGroup, this.state.pageCurent);
                    });
                    toast.success('利用者をグループから削除しました');
                } else {
                    this.setState({
                        showLoading: false,
                        showModalRemoveUsers: false,
                        message: nextProps.message,
                    }, () => {
                        this.props.getUsersOfGroups(this.state.idGroup, this.state.pageUserCurrent);
                    });
                    toast.success('利用者をグループから削除しました');
                }
            }
        }
    }

    getIdParamGroup = (text) => {
        this.setState({ showLoading: true });
        let id = this.props.match.params.id;
        let name = this.props.match.params.name
        this.setState({ idGroup: id, nameCompany: name })

        text === 'users' && this.props.getUsersOfGroups(id, 1);
        if (text === 'group') {
            this.props.getGroupsOfCompany(id, this.state.pageCurent);
            // this.props.getUsersInGroupsForDelete(id);
        }
    }

    handleChange = (inputName, value) => {
        // console.log(inputName, value);

        this.setState({ [inputName]: value },
            () => {
                // if (this.state.showModalAddUser) {
                    this.validateField(inputName, value);
                // }
            });
    }

    handleGroup = (text) => {
        this.setState({ showLoading: true });
        text === 'add' && this.props.addCompanyGroups(this.state.idGroup, this.state.name);
        text === 'edit' && this.props.editCompanyGroups(this.state.idGroup, this.state.nameEdit, this.state.idUserGroup);
        text === 'remove' && this.props.removeGroup(this.state.idGroup, this.state.idUserGroup);
    }

    onSearchGroups = (e) => {
        if (e.key === 'Enter') {
            this.setState({
                showLoading: true
            })
            if (this.state.isGroupSearch) {
                this.props.searchGroups(e.target.value, this.state.idGroup, this.state.pageCurent)
            } else {
                this.props.searchUsers(e.target.value, this.state.idGroup, this.state.pageUserCurrent)
            }
        }
    }

    activeButton = (e, boolean) => {
        const parent = document.getElementById('title-middle');
        parent.childNodes.forEach((val) => {
            val.style.color = '#6E7F8A';
            val.style.backgroundColor = '#E8ECEF';
        })
        e.target.style.color = 'white';
        e.target.style.backgroundColor = '#3D3DF2';
        if (boolean) {
            this.setState({ isShowTable: true, isGroupSearch: false }, () => {
                this.getIdParamGroup('users');
            })
        } else {
            this.setState({ isShowTable: false, isGroupSearch: true }, () => {
                this.getIdParamGroup('group');
            })
        }
    }

    onChangePage = (text, page, check) => {
        this.setState({ showLoading: true });
        if (text === 'users') {
            this.setState({ pageUserCurrent: page }, () => {
                this.props.getUsersOfGroups(this.state.idGroup, this.state.pageUserCurrent)
            })
        } else {
            this.setState({ pageCurent: page }, () => {
                this.props.getGroupsOfCompany(this.state.idGroup, this.state.pageCurent)
            })
        }
    }

    handleUsers = (action) => {
        this.setState({
            showLoading: true,
            showModalSettingUser: false
        });
        action === 'remove' && this.props.removeUserGroup(this.state.idGroup, this.state.idUser);
        let listGroup = [];
        this.state.listIdGroup.forEach(o => {
            listGroup.push(o.id)
        })
        let dataAdd = {
            name: this.state.nameAddUser,
            email: this.state.emailAddUser,
            emailUser: this.state.emailUser,
            listIdGroup: Array.from(new Set(listGroup)),
            remark: this.state.remarkAddUser,
            password: this.state.password ? this.state.password : null
        }

        if (this.state.showModalAddUser) {
            this.setState({ showModalSettingUser: true })
            action === 'edit' && this.props.addUsersGroups(this.state.idGroup, dataAdd);
        } else {
            action === 'edit' && this.props.editUserGroups(this.state.idGroup, dataAdd, this.state.idUser);
        }

    }

    showTable = () => {
        if (this.state.isShowTable) {
            return (
                <div className="user-list">
                    <Table
                        // showPagination={true}
                        showPaginationTop={true}
                        header={this.props.header}
                        onChangePage={(ev, check) => this.onChangePage('users', ev, check)}
                        showCheckbox={false}
                        showSearch={false}
                        itemOfPage={this.state.listUsersInGroup}
                        actionItemDropdownDot={(e, k, i) => this.actionItemDropdownDot(e, k, i)}
                        meta={this.state.meta}
                    />
                </div>
            )
        } else {
            return (
                <div className="group-list">
                    <Table
                        meta={this.state.meta}
                        showPaginationTop={true}
                        header={this.props.header1}
                        showCheckbox={false}
                        showSearch={false}
                        pageSize={5}
                        itemOfPage={this.state.listGroups}
                        onChangePage={(ev, check) => this.onChangePage('groups', ev, check)}
                        actionItemDropdownDot={(e, k, i) => this.actionItemDropdownDot2(e, k, i)} />
                </div>
            )
        }
    }

    actionItemDropdownDot = (_e, k, value) => {
        if (k === 0) {
            this.setState({
                idUser: value[0].idUser,
                nameAddUser: value[0].text,
                remarkAddUser: value[3].text,
                showModalSettingUser: true,
                emailUser: value[1].text,
                listGroupOfUser: value[2].group,
                showModalAddUser: false,
                formValid: true
            }, () => {
                this.showOptionInSelect();
            });

        } else {
            let nameGroup = '';
            if (value[2].group) {

                value[2].group.forEach((val, i) => {
                    if (i === value[2].group.length - 1) {
                        nameGroup += val.name;
                    } else {
                        nameGroup += val.name + ', ';
                    }
                })
            };

            this.setState({
                idUser: value[0].idUser,
                showModalRemoveUsers: true,
                emailUser: value[1].text,
                groupClient: nameGroup,
                companyClient: value[2].company
            });
        }
    }

    showOptionInSelect = () => {
        this.state.listIdGroup = [];
        this.state.listGroupOfUser.forEach((o) => {
            this.addOptionGroup(o.id)
        })
    }

    actionItemDropdownDot2 = (_e, k, value) => {
        if (k === 0) {
            this.setState({
                nameEdit: value[0].text,
                idUserGroup: value[0].idUserGroup,
                showModalEditGroup: true
            });
        } else if (k === 1) {
            let idComp = this.props.match.params.id
            this.setState({
                showAddUserGroup: true,
                showLoading: true,
                idGroup: value[0].idUserGroup,
                listUsersRemoveFake: this.state.listUsersRemove
            })
            this.props.getUsersInGroupsForDelete(idComp, value[0].idUserGroup)
        } else if (k === 2) {
            this.setState({
                name_company: value[0].name_company,
                idUserGroup: value[0].idUserGroup,
                showModalRemove: true,
                nameGroupToDelete: value[0].text
            });
        }
    }

    eventItemInButton = (text, k) => {
        if (k === 0) {
            this.setState({
                showModalSettingUser: true,
                showModalAddUser: true
            });
        } else {
            this.setState({ showModalAddGroup: true, showPopup: false });
        }
    }

    showButton = () => {
        if (this.state.isShowTable) {
            return (
                <Button
                    showIcon={true}
                    title="新規追加"
                    addData={() => this.actionAddData()}
                />
            )
        } else {
            return (
                <Button
                    indexEvent={(i, k) => this.eventItemInButton(i, k)}
                    showIcon={true}
                    isDropdown={true}
                    itemDropdown={this.props.arrButton}
                    title="新規追加"
                />
            )
        }
    }

    actionAddData = () => {
        this.setState({
            showModalAddUser: true,
            showModalSettingUser: true,
            nameAddUser: '',
            remarkAddUser: '',
            listGroupOfUser: [],
            listIdGroup: [],
            formValid: false
        });
    }


    hideAddToGroup = () => {
        this.setState({ showAddUserGroup: false })
    }

    componentDidMount = () => {
        this.getIdParamGroup('users');
    }

    componentDidUpdate = () => {
        this.hiddeDropdown('#btn-add-dropdown', 'dropdown-hidden')
    }

    hiddeDropdown = (p, c) => {
        const dropdownHidden = document.getElementById(c);
        if (dropdownHidden) {
            window.addEventListener('click', function (event) {
                if (!event.target.closest(p)) {
                    dropdownHidden.style.display = 'none';
                    setTimeout(() => {
                        dropdownHidden.classList.remove('showdropdown');
                    }, 100);
                }
            });
        }
    }

    commonHideComponent = (e, c) => {
        const isClickChild = e.target.classList.contains(c);
        if (isClickChild) {
            this.setState({
                showModalAddGroup: false,
                showAddUserGroup: false,
                showModalEditGroup: false,
                showModalRemove: false,
                showModalSettingUser: false,
                showModalRemoveUsers: false
            })
        }
    }

    changeCheckAddUser = (e, value) => {
        value.check = e.target.checked;
        const arrCheck = this.state.listUsersRemove.filter(val => {
            if (val.check !== null) {
                return val.group_id || val.check === true;
            } else {
                return val.group_id
            }
        });
        const listarr = arrCheck.filter(x => x.check !== false)
        this.setState({ listUsersRemoveFake: listarr });

    }

    deleteGroupOfUser = (id) => {
        let arr = [];
        let arrName = [];
        this.state.listGroupOfUser.map(value => {
            if (value.id !== id) {
                arr.push(value.id);
                arrName.push(value)
            }
            return true;
        })
        this.setState({
            listIdGroup: arr,
            listGroupOfUser: arrName
        })

    }

    deleteUserOutGroup = () => {
        this.setState({ showLoading: true, showAddUserGroup: false });
        const id = +this.props.match.params.id;
        const arrFilter = this.state.listUsersRemoveFake.filter(val => val.check !== false);
        const arr = arrFilter.map(val => val.id);
        this.props.updateUserOfGroupCompany(arr, id, this.state.idGroup)
    }

    addOptionGroup = (id) => {
        const wrapTotalGroup = document.getElementById('wrap-total-group');
        let select = document.createElement('SELECT');
        let index = 0;
        let newGroups = [];
        for (var i = 0; i <= this.state.listGroups.length - 1; i++) {
            if (this.state.listGroups.length < 2) {
                this.setState({
                    listIdGroup: [this.state.listGroups[0].item[0].idUserGroup]
                })
            }
            let time = new Date().getTime()
            var opt = document.createElement('option');
            let item = {
                name: this.state.listGroups[i].item[0].text,
                id: this.state.listGroups[i].item[0].idUserGroup,
                info: this.state.listGroups[i].item[0],
                time: time
            }
            opt.value = JSON.stringify(item)
            newGroups.push(item)
            if (i == 0 && !id) {
                this.state.listIdGroup.push({
                    time: time,
                    id: this.state.listGroups[i].item[0].idUserGroup
                })
            }
            opt.innerHTML = this.state.listGroups[i].item[0].text;
            select.appendChild(opt);
        }

        for (let i = 0; i < newGroups.length; i++) {
            if (newGroups[i].id == id) {
                index = i
                this.state.listIdGroup.push({
                    time: newGroups[i].time,
                    id: newGroups[i].id
                })
            }
        }

        select.selectedIndex = index;

        let divParent = document.createElement('div');
        let divImg = document.createElement('div');
        let img = document.createElement('img');
        img.setAttribute('src', '/img/ic_remove2_svg.svg');
        divImg.appendChild(img);
        img.addEventListener('click', () => {
            let idGroup = this.state.listIdGroup.filter(o => {
                return o.id !== id;
            })
            this.setState({
                listIdGroup: idGroup
            })


            divParent.remove();
        })
        divParent.appendChild(select);
        divParent.appendChild(divImg);
        wrapTotalGroup.appendChild(divParent);
        select.addEventListener('change', (e) => {
            const arrIdGroup = this.state.listIdGroup;
            const event = JSON.parse(e.target.value);
            let obj = arrIdGroup.find(o => {
                return o.time == event.time
            })
            if (obj) {
                obj.id = event.id;
            } else {
                arrIdGroup.push({
                    time: event.time,
                    id: event.id
                })
            }

            this.setState({
                listIdGroup: arrIdGroup
            });
        });
    }

    navigateAdminCompany = () => {
        this.props.history.push('/admin-company');
    }

    render() {
        return (
            <Fragment>
                <div className="client--list">
                    <div className="client--list-top">
                        <div className="title-left">
                            <img src="/img/ic_back.png" alt="back" onClick={() => this.navigateAdminCompany()} />
                            <h4>企業名</h4>
                        </div>
                        <div className="title-middle" id="title-middle">
                            <button className="btn-list-user" onClick={(e) => this.activeButton(e, true)}>個人</button>
                            <button className="btn-list-user" onClick={(e) => this.activeButton(e, false)}>グループ</button>
                        </div>
                        <div style={{ display: 'flex' }}>
                            <div className="search-custom">
                                <input type="text" className="searchbox" placeholder="検索"
                                    onKeyDown={(e) => this.onSearchGroups(e)} />
                            </div>
                            {this.showButton()}
                        </div>
                    </div>
                    <div className="client--list-bottom">
                        {this.showTable()}
                    </div>
                </div>

                {/* add group */}
                {
                    this.state.showModalAddGroup ?
                        <div className="wrap-add-group" onClick={(e) => this.commonHideComponent(e, 'wrap-add-group')}>
                            <div className="add-group">
                                <h4>グループ追加</h4>
                                <div>
                                    <input onChange={(e) => this.handleChange('name', e.target.value)} type="text" placeholder="グループ名を入力してください" />
                                </div>
                                <div className="group-btn-add">
                                    <button onClick={() => this.setState({ showModalAddGroup: false, name: '' })}>キャンセル</button>
                                    <button
                                        disabled={this.state.name === ''}
                                        onClick={() => this.handleGroup('add')}
                                    >追加</button>
                                </div>
                            </div>
                        </div> : null
                }

                {/* edit group */}
                {this.state.showModalEditGroup ?
                    <div className="wrap-edit-group" onClick={(e) => this.commonHideComponent(e, 'wrap-edit-group')}>
                        <div className="edit-group" >
                            <h4>グループ名変更</h4>
                            <div>
                                <input type="text"
                                    value={this.state.nameEdit}
                                    onChange={(e) => this.handleChange('nameEdit', e.target.value)}
                                    placeholder="グループ名を入力してください" />
                            </div>
                            <div className="group-btn-add">
                                <button onClick={() => this.setState({ showModalEditGroup: false })}>キャンセル</button>
                                <button disabled={this.state.nameEdit === ''} onClick={() => this.handleGroup('edit')}>変更</button>
                            </div>
                        </div>
                    </div> : null
                }

                {/* add user to group */}
                {
                    this.state.showAddUserGroup
                        ? <div id="add-user-group" className='add-user-group' onClick={(e) => this.commonHideComponent(e, 'add-user-group')}>
                            <div className="user-to-group" id="user-to-group">
                                <p>グループのユーザーを選択</p>
                                <ul>
                                    {this.state.listUsersRemove.map((value, key) => {
                                        return (
                                            <li key={key.toString()}>
                                                <span>{value.name}</span>
                                                <div className="md-checkbox-custom">
                                                    <input id={key} type="checkbox" checked={this.state.listUsersRemove[key].check} onChange={(e) => this.changeCheckAddUser(e, value)} />
                                                    <label htmlFor={key}></label>
                                                </div>
                                            </li>
                                        )
                                    })}
                                </ul>
                                <div className="group-btn">
                                    <button onClick={() => this.hideAddToGroup()}>キャンセル</button>
                                    <button onClick={() => this.deleteUserOutGroup()}>追加</button>
                                </div>
                            </div>
                        </div>
                        : null
                }


                {/* setting company */}
                {
                    this.state.showModalSettingUser ?
                        <div className="wrap-users-setting" onClick={(e) => this.commonHideComponent(e, 'wrap-users-setting')}>
                            <div className="company-setting">
                                <h4>{this.state.showModalAddUser ? '利用者追加' : '編集'}</h4>
                                {
                                    this.state.showModalAddUser
                                        ? <div>
                                            <label>ログインID</label>
                                            <div>
                                                <input
                                                    placeholder="ログインIDを入力してください"
                                                    type="text"
                                                    onChange={(e) => this.handleChange('emailAddUser', e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        : null
                                }
                                <div>
                                    <label>名前</label>
                                    <div>
                                        <input value={this.state.nameAddUser}
                                            onChange={(e) => this.handleChange('nameAddUser', e.target.value)}
                                            placeholder="名前を入力してください" type="text" />
                                    </div>
                                </div>
                                <div>
                                    <label>パスワード</label>
                                    <div>
                                        <input
                                            onChange={(e) => this.handleChange('password', e.target.value)}
                                            placeholder="パスワードを入力してください" type="password"  autocomplete="new-password"
                                        />
                                    </div>
                                </div>
                                {
                                    <div className="wrap-group-option">
                                        <label>グループ</label>
                                        <div>
                                            <div id="wrap-total-group">
                                            </div>
                                            <div className='btn-add-group'>
                                                <button onClick={() => this.addOptionGroup()}>グループを追加</button>
                                            </div>
                                        </div>

                                    </div>
                                }

                                <div className='form-textarea'>
                                    <label>備考</label>
                                    <div >
                                        <textarea
                                            value={this.state.remarkAddUser}
                                            onChange={(e) => this.handleChange('remarkAddUser', e.target.value)}
                                            />
                                    </div>
                                </div>
                                <div>
                                    <button onClick={() => this.setState({ showModalSettingUser: false })}>キャンセル</button>
                                    <button
                                        onClick={() => this.handleUsers('edit')}
                                        disabled={
                                            // this.state.showModalAddUser ?
                                                !this.state.formValid
                                                // : this.state.passwordValid
                                        }
                                    >{this.state.showModalAddUser ? '追加' : '編集'}</button>
                                </div>
                            </div>
                        </div> : null
                }


                {/* Remove groups in company */}
                {
                    this.state.showModalRemove ?
                        <div className="wrap-group-delete" onClick={(e) => this.commonHideComponent(e, 'wrap-group-delete')}>
                            <div className="group-delete">
                                <h4>グループの削除</h4>
                                <p>このグループを削除します。本当によろしいですか？</p>
                                <div>
                                    <div>
                                        <label>所属企業 : </label>
                                        {/* <span>{this.state.nameCompany}</span> */}
                                        <span>{this.state.name_company} </span>
                                    </div>
                                    <div>
                                        <label>所属グループ : </label>
                                        <span>{this.state.nameGroupToDelete}</span>
                                    </div>
                                </div>
                                <div>
                                    <button onClick={() => this.setState({ showModalRemove: false })}>キャンセル</button>
                                    <button onClick={() => this.handleGroup('remove')}>削除</button>
                                </div>
                            </div>
                        </div> : null
                }

                {/* delete user in group */}
                {
                    this.state.showModalRemoveUsers ?
                        <div className="wrap-client-delete" onClick={(e) => this.commonHideComponent(e, 'wrap-client-delete')} >
                            <div className="client-delete">
                                <h4>ユーザーの削除</h4>
                                <p>このユーザーを削除します。本当によろしいですか？</p>
                                <div>
                                    <div>
                                        <label>ログインID : </label>
                                        {/* <span>{this.state.nameItemCompany}</span>
                                    </div>
                                    <div>
                                        <label>所属企業 : </label>
                                        <span>{this.state.nameCompany}</span>
                                    </div>
                                    <div>
                                        <label>所属グループ : </label>
                                        <span>{this.state.nameGroupToDelete}</span> */}
                                        <span>{this.state.emailUser}</span>
                                    </div>
                                    <div>
                                        <label>所属企業 : </label>
                                        <span>{this.state.companyClient}</span>
                                    </div>
                                    <div>
                                        <label>所属グループ : </label>
                                        <span>{this.state.groupClient}</span>
                                    </div>
                                </div>
                                <div>
                                    <button onClick={() => this.setState({ showModalRemoveUsers: false })}>キャンセル</button>
                                    <button onClick={() => this.handleUsers('remove')}>削除</button>
                                </div>
                            </div>
                        </div> : null
                }
                <Loading show={this.state.showLoading} />
            </Fragment>
        )
    }
}
const mapStateToProps = ({ adminUserList }) => {
    return {
        header: adminUserList.header,
        header1: adminUserList.header1,
        response: adminUserList.response,
        status: adminUserList.status,
        arrButton: adminUserList.arrButton,
        message: adminUserList.message,
        listRemove: adminUserList.list,
        meta: adminUserList.meta,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getGroupsOfCompany: (id, page) => {
            dispatch(getGroupsOfCompany(id, page));
        },
        addCompanyGroups: (id, name) => {
            dispatch(addCompanyGroups(id, name));
        },
        editCompanyGroups: (idGroup, name, idEdit) => {
            dispatch(editCompanyGroups(idGroup, name, idEdit));
        },
        searchGroups: (text, groupId, page) => {
            dispatch(searchGroups(text, groupId, page));
        },
        removeGroup: (idComp, idGroup) => {
            dispatch(removeGroup(idComp, idGroup));
        },
        getUsersOfGroups: (id, page) => {
            dispatch(getUsersOfGroups(id, page));
        },
        addUsersGroups: (id, name) => {
            dispatch(addUsersGroups(id, name));
        },
        editUserGroups: (idGroup, data, idEdit) => {
            dispatch(editUserGroups(idGroup, data, idEdit));
        },
        removeUserGroup: (idComp, idUser) => {
            dispatch(removeUserGroup(idComp, idUser));
        },
        searchUsers: (text, groupId, page) => {
            dispatch(searchUsers(text, groupId, page));
        },
        getUsersInGroupsForDelete: (idComp, idGroup) => {
            dispatch(getUsersInGroupsForDelete(idComp, idGroup));
        },
        updateUserOfGroupCompany: (data, idComp, idGroup) => {
            dispatch(updateUserOfGroupCompany(data, idComp, idGroup));
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(AdminUserList);
